import { EventSlot } from '../../plugins/api'

export default {
  namespaced: true,
  state: {
    items: [],
    //
    searchParams: {}
  },
  actions: {
    async fetchAll({ commit, state }, params) {
      const searchParams = { ...state.searchParams, ...params }
      const data = await EventSlot.fetch(searchParams)
      commit('changeState', { items: data, searchParams })
    },
    async create({ dispatch }, params) {
      await EventSlot.create(params)
      dispatch('fetchAll', {})
    },
    async update({ dispatch }, { id, ...params }) {
      await EventSlot.update(id, params)
      dispatch('fetchAll', {})
    },
    async updateIndex({ dispatch }, { id, ...params }) {
      await EventSlot.updateIndex(id, params)
      dispatch('fetchAll', {})
    },
    async remove({ dispatch }, id) {
      await EventSlot.remove(id)
      dispatch('fetchAll', {})
    }
  },
  mutations: {},
  getters: {
    getItems: state => state.items
  }
}
